import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import types from 'actions/types'
import {get} from 'lodash'
import {getPivotTableTotalReducer} from "helpers/pivotTable"

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const raisedBy = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.raisedBy', state)
    default:
      return state
  }
}

export const printedEmailed = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.printedEmailed', state)
    default:
      return state
  }
}

export const dateTypes = (state = [], action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

const total = (state = null, action) => {
  return getPivotTableTotalReducer(state, action, invoicingContextReceivedNotInvoicedPivotTableKey)
}

export const invoicingContextReceivedNotInvoicedPivotTableKey = 'invoicingContext.receivedNotInvoiced.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: invoicingContextReceivedNotInvoicedPivotTableKey, defaultSortColumn: 'desc'}),
  companies,
  raisedBy,
  printedEmailed,
  dateTypes,
  timeKey,
  targetStart,
  targetEnd,
  total,
})
